
(function ($) {
    $.fn.glanceTable = function () {
        return this.each(function () {
            var c, header, nav, content;

            c = $(this);
            header = c.find('.glance-header');
            nav = c.find('.glance-nav').clone();
            content = c.find('.glance-content');

            nav.removeClass().addClass('glance-menu');
            header.append(nav);

            //Select First item
            header.find('li').first().addClass('active');
            content.find('.row').each(function (e) {
                $(this).find('.value').first().addClass('active')
            });
            nav.find('li').first().addClass('active');


            $('.glance-nav').on('mouseenter', 'li', function (e) {
                e.preventDefault();
                header.toggleClass('open', true);
                $('.glance-menu-overlay').toggleClass('hover-on', true);
            });

            $('.glance-menu-overlay').on('mouseenter', function (e) {
                e.preventDefault();
                header.toggleClass('open', false);
                $('.glance-menu-overlay').toggleClass('hover-on', false);
            });

            nav.on('click', 'li', function (e) {
                e.preventDefault();
                if(!$(this).hasClass('active')) {
                    var target = '.'+$(this).attr('class');
                    c.find('.active').removeClass('active');
                    header.find(target).addClass('active');
                    content.find(target).addClass('active');
                }

                header.toggleClass('open', false);
                $('.glance-menu-overlay').toggleClass('hover-on', false);
            });

        });
    };
})(jQuery);